import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Subscription } from 'rxjs';

// Components
import { ButtonComponent } from '../../../../../../shared/_components/button/button.component';
import { FlowMediaUploadStep } from '../../flows/flow-media-upload/step/flow-media-upload-step.component';

// Services
import { MediaAssetService } from '../../../services/media-asset.service';
import { GetAssetStatusResponse } from '@oddr/user-services';
import { Statuses } from '@oddr/user-schemas';

@Component({
  selector: 'pp-step-media-video-complete',
  templateUrl: './step-media-video-complete.component.html',
  styleUrl: './step-media-video-complete.component.scss',
  imports: [CommonModule, ButtonComponent],
})
export class StepMediaVideoCompleteComponent extends FlowMediaUploadStep {

  // Component handler (!IMPORTANT - Must match step identifier for this flow)
  identifier = 'mediaUploadFlowStepVideoComplete';

  // Aliases
  statuses = Statuses;

  // Form handlers
  pollingStatusUpdate?: GetAssetStatusResponse;

  // Services
  private readonly mediaAssetService = inject(MediaAssetService);

  // Subscriptions
  private readonly processingPollingStatus$?: Subscription;

  constructor() {
    super();

    this.processingPollingStatus$ = this.mediaUploadService.processingPollingStatus$.subscribe({
      next: (response: GetAssetStatusResponse) => {
        this.pollingStatusUpdate = response;
        this.cdr.markForCheck();
      },
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.processingPollingStatus$?.unsubscribe();
  }

  get oddrLink(): string {
    return `${location.origin}/m/${this.operation?.assetId}`;
  }

  copyThumbnailUrlToClipboard(): void {
    navigator.clipboard.writeText(this.oddrLink);
  }

  downloadC2paSignedCopy(): void {
    if (this.operation) this.mediaAssetService.downloadC2paSignedCopy(this.operation?.assetId).subscribe();
  }

  resolveC2paStatusIcon(status: any): string {
    switch (status) {
      case Statuses.Failed:
        return this.resolveImageIcon('circle-question-mark')
      case Statuses.Complete:
        return '/assets/images/icons/check-circle-solid-primary.svg';
      default:
        return this.resolveImageIcon('time');
    }
  }

  submitAndCompleteFlow(): void {
    this.mediaUploadService.postUploadConfigurationForIntegrations().subscribe({
      next: () => this.completeFlow(),
    });
  }
}
